(function() {
    const refreshCart = () => {
        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                // Compteurs panier Prestige
                document.querySelectorAll('[data-cart-count]').forEach(el => {
                    el.textContent = cart.item_count;
                    el.closest('[data-cart-count-bubble]')?.classList.toggle('hidden', cart.item_count === 0);
                });
                // Déclenche l'événement natif Prestige
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
            });
    };

    // Intercepte tous les appels /cart/add.js (wishlist ou autre)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        return originalFetch.apply(this, args).then(response => {
            if (url.includes('/cart/add')) {
                response.clone().json().then(() => setTimeout(refreshCart, 300));
            }
            return response;
        });
    };
})();